export class ProgressBarDetails {
    locationPB: string = "false";
    contactPB: string = "false";
    placardPB: string = "false";
    pickupPB: string = "false";
    notificationPB: string = "false";
    showStatusBar: boolean = true;
}